<template>
  <div>
    <user-list />
  </div>
</template>

<script>
import UserList from '@/views/AadenPages/memberShipReborn/userManagement/UserList.vue'

export default {
  name: 'UserManagement',
  components: {
    UserList
  }
}
</script>

<style scoped>
</style>
